import { MenuItem, Select } from "@mui/material"
import FormControl from "@mui/material/FormControl"
import { SelectInputProps } from "@mui/material/Select/SelectInput"
import { makeStyles } from "tss-react/mui-compat";
import { AdminUserCard } from "components/AdminUserCard"
import AdminUser from "models/convention-api/v1/AdminUser"

interface IAdminUserSelect {
  adminUsers: AdminUser[]
  selectedAdminUserId: string
  onSelectedAdminChange: SelectInputProps["onChange"]
}

export default function AdminUserSelect(props: IAdminUserSelect) {
  const { classes } = useStyles()

  return (
    <FormControl variant="filled">
      <Select
        className={classes.root}
        classes={{ select: classes.selectRoot }}
        MenuProps={{
          classes: {
            paper: classes.menuPaper,
            list: classes.menuListContainer,
          },
        }}
        SelectDisplayProps={{ "aria-label": "Select admin user" }}
        value={props.selectedAdminUserId}
        onChange={props.onSelectedAdminChange}
        disableUnderline>
        {props.adminUsers.map((adminUser) => {
          return (
            <MenuItem
              aria-label={adminUser.name}
              className={classes.menuListItem}
              key={adminUser.id}
              value={adminUser.id}>
              <AdminUserCard adminUser={adminUser} />
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}


const useStyles = makeStyles()(
  (theme) => ({
    root: {
      width: "100%",

      "& > .MuiSvgIcon-root": {
        color: theme.palette.gray.dark,
      },
    },
    selectRoot: {
      padding: 0,
      backgroundColor: theme.palette.gray.lightest,
      whiteSpace: "normal",
      "&:focus": {
        backgroundColor: theme.palette.gray.lightest,
      },
      "& > .MuiBox-root ": {
        borderBottom: 0,
      },
    },
    menuPaper: {
      maxHeight: 300,
      borderRadius: 10,
      border: "1px solid",
    },
    menuListContainer: {
      padding: 0,
      "& > * + * > div": {
        borderTop: `1px solid ${theme.palette.gray.main}`,
      },
    },
    menuListItem: {
      padding: "0 15px",
      whiteSpace: "normal",
    },
  })
)